module.exports = __webpack_public_path__ + "img/sr-active.1cfabb4e.png";